import { Button, ButtonGroup, Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { BinTypes } from '../../../domain/analytics/BinTypes';
import { useAnalyticsFilters } from './hooks/useAnalyticsFilters';

export const AnalyticsBinTypeContainer = () => {
  const intl = useIntl();
  const { binType: currentBinType, setBinType } = useAnalyticsFilters();

  return (
    <Grid container direction="row" style={{ padding: `12px 0` }}>
      <ButtonGroup
        variant="text"
        aria-label="analytics tabs"
        sx={{
          width: `100%`,
          padding: `6px`,
          borderRadius: `10px`,
          border: `1px solid #F9FAFB33`,
          backgroundColor: `transparent`,
          gap: `12px`,
        }}
        disableRipple
      >
        {([`week`, `day`] as BinTypes[]).map((binType) => {
          let label;
          if (binType === `day`) {
            label = intl.formatMessage({ id: `drivers.analytics.bin_type.week` });
          }
          if (binType === `week`) {
            label = intl.formatMessage({ id: `drivers.analytics.bin_type.month` });
          }

          return (
            <Button
              key={binType}
              value={binType}
              onClick={() => {
                setBinType(binType);
              }}
              disableRipple
              sx={{
                height: `34px`,
                width: `100%`,
                padding: `6px 0`,
                color: RoutalPalette.neutral05,
                borderRadius: `5px!important`,
                border: `none!important`,
                textTransform: `none`,
                fontSize: `13px`,
                fontStyle: `normal`,
                fontWeight: 400,
                lineHeight: `normal`,
                '&.MuiButton-root': {
                  backgroundColor: binType === currentBinType ? RoutalPalette.primary60 : `transparent`,
                  color: binType === currentBinType ? RoutalPalette.neutral02n : RoutalPalette.neutral05,
                },
              }}
            >
              {label}
            </Button>
          );
        })}
      </ButtonGroup>
    </Grid>
  );
};
